<template>
  <section>
    <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :show-close="true" :error-msg="errorMsg" @close="closeDialog" />
    <sys-loading :loading="loading" />
    <div class="container" v-if="!isMobile">
      <img class="logo" src="../assets/8day-logo.png" />
      <div class="left">
        <div class="title">
          <img src="../assets/sport/title.png" />
        </div>
        <div class="form">
          <div class="tag">
            <div class="tag-item reg" :class="isRegisterAction ? 'active' : ''" @click="isRegisterAction = true">
              ĐĂNG KÝ
            </div>
            <div class="tag-item login" :class="!isRegisterAction ? 'active' : ''" @click="isRegisterAction = false">
              ĐĂNG NHẬP
            </div>
          </div>
          <div class="form-input">
            <img src="../assets/sport/icon-user.png" />
            <input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
          </div>
          <div class="form-input" v-show="isRegisterAction">
            <img src="../assets/sport/icon-phone.png" />
            <input v-model="form.phone" placeholder="Số điện thoại" maxlength="10" oninput="value=value.replace(/^\D/, '')" />
          </div>
          <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
            <img src="../assets/sport/icon-password.png" />
            <input v-model="form.password" type="password" autocomplete="new-password" placeholder="Mật khẩu" />
          </div>
          <div class="form-input" v-show="isRegisterAction">
            <img src="../assets/sport/icon-email.png" />
            <input v-model="form.email" autocomplete="off" placeholder="Email" />
          </div>
          <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;position: relative;">
            <input v-model="form.verificationCode" maxlength="4" autocomplete="off" />
            <div class="codeImg">
              <span @click="getVerify" v-if="codeImg" class="validateCode">
                <img class="img" :src="codeImg" alt="code" />
              </span>
            </div>
          </div>
          <a v-if="!isRegisterAction" href="https://www.8day.com">Quên mật khẩu ?</a>
          <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" @cb="handleConfirm" :vstyle="{ top: '41px' }" :nativeButton="{
              width: '332px',
              height: '84px'
            }">
            <div v-show="isRegisterAction" class="btn btn-reg" @click="submitAction(1)">
              <span>ĐĂNG KÝ</span>
              <img src="../assets/sport/icon-80k.png" />
            </div>
          </v-captcha>
          <div v-show="!isRegisterAction" class="btn" @click="submitAction(2)">
            ĐĂNG NHẬP
          </div>
        </div>
        <div class="cts">
          <a :href="contacts.facebook" target="_blank">
            <img src="../assets/icon-fb.png" />
          </a>
          <a :href="contacts.telegram" target="_blank">
            <img src="../assets/icon-tg.png" />
          </a>
        </div>
      </div>
    </div>
    <div class="root" v-if="isMobile">
      <img class="logo" src="../assets/8day-logo.png" />
      <img class="title" src="../assets/sport/title-h5.png" />
      <div class="form">
        <div class="tag">
          <div class="tag-item reg" :class="isRegisterAction ? 'active' : ''" @click="isRegisterAction = true">
            ĐĂNG KÝ
          </div>
          <div class="tag-item login" :class="!isRegisterAction ? 'active' : ''" @click="isRegisterAction = false">
            ĐĂNG NHẬP
          </div>
        </div>
        <div class="form-input">
          <img src="../assets/sport/icon-user.png" />
          <input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
        </div>
        <div class="form-input" v-show="isRegisterAction">
          <img src="../assets/sport/icon-phone.png" />
          <input v-model="form.phone" placeholder="Số điện thoại" maxlength="10" oninput="value=value.replace(/^\D/, '')" />
        </div>
        <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
          <img src="../assets/sport/icon-password.png" />
          <input v-model="form.password" type="password" autocomplete="new-password" placeholder="Mật khẩu" />
        </div>
        <div class="form-input" v-show="isRegisterAction">
          <img src="../assets/sport/icon-email.png" />
          <input v-model="form.email" autocomplete="off" placeholder="Email" />
        </div>
        <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;position: relative;">
          <input v-model="form.verificationCode" maxlength="4" autocomplete="off" />
          <div class="codeImg">
            <span @click="getVerify" v-if="codeImg" class="validateCode">
              <img class="img" :src="codeImg" alt="code" />
            </span>
          </div>
        </div>
        <a v-if="!isRegisterAction" href="https://www.8day.com">Quên mật khẩu ?</a>
        <v-captcha ref="vcaptcha2" :dialogVisible="dialogVisible" :showCheck="showCheck" @cb="handleConfirm" :vstyle="{
            width: '75%',
            top: '2vh'
          }" :nativeButton="{
            width: '100%',
            height: '8vh'
          }">
          <div v-show="isRegisterAction" class="btn btn-reg" @click="submitAction(1)">
            <span>ĐĂNG KÝ</span>
            <img src="../assets/sport/icon-80k.png" />
          </div>
        </v-captcha>
        <div v-show="!isRegisterAction" class="btn" @click="submitAction(2)">
          ĐĂNG NHẬP
        </div>
      </div>
      <div class="cts">
        <a :href="contacts.facebook" target="_blank">
          <img src="../assets/icon-fb.png" />
        </a>
        <a :href="contacts.telegram" target="_blank">
          <img src="../assets/icon-tg.png" />
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import md5 from "js-md5";
import {
  FORM_VALID_MESSAGE,
  DOMAIN_AGENT_CODE,
  CONTRACTS
} from "../utils/constant";
import { userRegister, userLogin, createCustomer, getCode } from "../utils/request";
import { encodePlatformUrl, validForm, isMobile } from "../utils/tools";
import { captcha } from "@/mixins/captcha";
export default {
  name: "Sport",
  mixins: [captcha],
  data() {
    return {
      isMobile: isMobile(),
      loading: false,
      isRegisterAction: true,
      dialogVisible: false,
      dialogBgi: require("../assets/sport/bgi-dialog.png"),
      contacts: CONTRACTS,
      form: {
        by: 1,
        username: "",
        verificationCode: "",
        userName: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      },
      errorMsg: {
        title: "",
        content: ""
      },
      codeImg: ''
    };
  },
  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    this.getVerify();
  },
  methods: {
    getVerify() {
      getCode({}).then(res => {
        this.codeImg = res.body.data
      })
    },
    submitAction(type) {
      let errorMsg = validForm(type, this.form);
      if (Object.keys(errorMsg).length !== 0) {
        this.setDialogMsg(errorMsg.title, errorMsg.content);
        return;
      }

      // 登陆
      if (type == 2) {
        this.loading = true;
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.userName,
          phone: temp.phone,
          password: md5(temp.password)
        };
        this.login(params);
      } else {
        const inviteCode = DOMAIN_AGENT_CODE[location.host] || "";
        this.form.inviteCode = inviteCode;
        this.form.domain = location.host;
        this.form.username = this.form.userName;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg
            );
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      let params = (this.params = Object.assign({}, this.form));
      if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
        this.setDialogMsg(
          FORM_VALID_MESSAGE.registerFailTitle,
          FORM_VALID_MESSAGE.passwordMsg
        );
        return;
      }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      this.loading = true;
      params.userName = this.form.userName.toLowerCase();
      params.password = md5(this.form.password);
      params.email = this.form.email;
      params.verificationCode = this.form.verificationCode;
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.getVerify();
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  height: 100vh;
  background-image: url("../assets/sport/bgi-pc.jpg");
  background-size: 100% 100%;
  overflow: hidden;

  img.logo {
    position: fixed;
    top: 50px;
    left: calc(50% - 145px);
  }

  .left {
    width: 28%;
    float: left;
    margin-left: 230px;
    padding-top: 100px;
    text-align: center;

    .title {
      font-family: Montserrat, UTMErieBlack;
      font-size: 36px;
      color: #fff;
      p {
        margin: 10px;
        &:last-child {
          margin-top: 40px;
          text-indent: -5em;
          position: relative;
          img {
            width: 200px;
            position: absolute;
            top: -22px;
            right: 35px;
          }
        }
      }
    }
    .form {
      background-image: url("../assets/sport/bgi-form.png");
      background-size: 100% 100%;
      position: relative;
      height: fit-content;
      width: 80%;
      margin: 30px auto 0;
      padding-bottom: 10px;

      a {
        color: #00ffe6;
        position: relative;
        top: 20px;
      }

      .tag {
        line-height: 40px;
        margin-left: 10px;

        .tag-item {
          width: 40%;
          float: left;
          color: #ffffff;
          font-size: 20px;
          font-style: normal;
          font-weight: bold;
          cursor: pointer;
        }

        .active {
          background-image: url("../assets/sport/bgi-tag-active.png");
          background-size: 100% 100%;
          width: 58%;
          height: 60px;
          line-height: 60px;
          position: relative;
          top: -20px;
          font-size: 30px;
        }
      }

      .form-input {
        width: 70%;
        margin: 0 auto 20px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 10px 20px;
        background-size: 100% 100%;
        transition: all 0.25s ease;
        border-radius: 20px;
        background-image: url("../assets/sport/bgi-form-input.png");
        .codeImg {
          cursor: pointer;
          width: 150px;
          height: 100%;
          position: absolute;
          right: 0;
          top: 1px;
          .img {
            width: 150px;
            height: 100%;
            border-radius: 20px;
          }
        }
        img {
          margin-right: 10px;
        }

        input {
          border: none;
          outline-width: 0;
          background-color: transparent;
          height: 34px;
          width: 300px;
          font-family: UTMAvo;
          font-weight: 500;
          font-size: 25px;
          color: #fff;
          padding: 1px 2px;
        }

        input::placeholder {
          color: #ffffff;
          font-size: 22px;
          font-style: normal;
          font-weight: normal;
        }
      }

      .btn {
        width: 332px;
        height: 84px;
        line-height: 76px;
        margin: 0 auto;
        background-image: url("../assets/sport/bgi-btn.png");
        background-size: 100% 100%;
        font-size: 30px;
        font-weight: bold;
        color: #ffffff;
        cursor: pointer;
        position: relative;
        top: 41px;
        &:active {
          top: 43px;
        }
        img {
          position: relative;
          top: 7px;
        }
      }
    }
    .cts {
      text-align: center;
      margin-top: 40px;

      img {
        margin: 10px;
      }
    }
  }
}
.root {
  background-image: url("../assets/sport/bgi-h5.jpg");
  background-size: 100% 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  padding-bottom: 30vh;

  img.logo {
    width: 29.21vw;
    margin-top: 3vh;
  }

  img.title {
    width: 80%;
    margin-bottom: 2vh;
  }

  p {
    font-size: 2em;
    font-weight: bold;
    margin: 0;
    color: #ffffff;

    img {
      width: 40vw;
      position: relative;
      top: 18px;
      left: 10px;
    }
  }

  .form {
    background-image: url("../assets/sport/bgi-form.png");
    background-size: 100% 100%;
    position: relative;
    height: fit-content;
    width: 75%;
    margin-top: 3vh;

    a {
      color: #00ffe6;
      text-align: center;
      display: block;
    }

    .tag {
      line-height: 40px;
      margin-left: 2px;

      .tag-item {
        width: 40%;
        float: left;
        color: #ffffff;
        font-size: 1em;
        text-align: center;
        font-style: normal;
        font-weight: bold;
      }

      .active {
        background-image: url("../assets/sport/bgi-tag-active.png");
        background-size: 100% 100%;
        width: 58%;
        line-height: 50px;
        position: relative;
        top: -20px;
        font-size: 1.5em;
        text-align: center;
      }
    }

    .form-input {
      width: 70%;
      margin: 0 auto 10px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 5px 10px;
      background-size: 100% 100%;
      transition: all 0.25s ease;
      border-radius: 20px;
      background-image: url("../assets/sport/bgi-form-input.png");

      .codeImg {
        cursor: pointer;
        width: 150px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 1px;
        .img {
          width: 150px;
          height: 100%;
          border-radius: 20px;
        }
      }

      img {
        margin-right: 10px;
      }

      input {
        font-family: UTMAvo;
        border: none;
        outline-width: 0;
        background-color: transparent;
        height: 34px;
        width: 300px;
        font-size: 1em;
        color: #ffffff;
      }

      input::placeholder {
        color: #ffffff;
        font-size: 1em;
        font-style: normal;
        font-weight: normal;
      }
    }

    .btn {
      width: 75%;
      height: 8vh;
      line-height: 7vh;
      text-align: center;
      margin: 0 auto;
      font-size: 1.5em;
      font-weight: bold;
      color: #ffffff;
      position: relative;
      top: 2vh;
      background-image: url("../assets/sport/bgi-btn.png");
      background-size: 100% 100%;

      img {
        position: relative;
        top: 4px;
        width: 20vw;
      }
    }
  }

  .cts {
    text-align: center;
    margin-top: 2vh;

    img {
      width: 12vw;
      margin: 10px;
    }
  }

  img.img-btm {
    width: 70%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sport.vue